<template>
  <sea-page-content toolbar hideRapidSearch in-tab>
    <v-card flat tile>
      <v-card-title class="justify-center flex-column">
        <div class="text-center title text-h6">
          Dettaglio {{ mesi[payroll.mese - 1] }} {{ payroll.anno }}
        </div>
        <div class="text-center font-weight-bold subtitle-1">
          {{ payroll.descrizione }}<br />
          Netto {{ payroll.netto | currencyFormat }}
        </div>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters class="hidden-sm-and-up">
          <v-col cols="12">
            <v-card outlined flat tile>
              <div class="text-center head">Totale lordo</div>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ payroll.totaleLordo | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile
              ><div class="text-center head">Ritenute sociali</div></v-card
            >
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ payroll.ritenuteSociali | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile
              ><div class="text-center head">Ritenute fiscali</div></v-card
            >
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ payroll.ritenuteFiscali | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile
              ><div class="text-center head">Addizionali Irpef</div></v-card
            >
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ payroll.addizionaliIrpef | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile
              ><div class="text-center head">Conguaglio fiscale</div></v-card
            >
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ payroll.conguaglioFiscale | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile
              ><div class="text-center head">Arrotondamento</div></v-card
            >
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ payroll.arrotondamento | currencyFormat }}
              </div></v-card
            >
          </v-col>
        </v-row>
        <v-row no-gutters class="hidden-lg-and-up">
          <v-col cols="4">
            <v-card outlined flat tile>
              <div class="text-center head">Totale lordo w</div>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile
              ><div class="text-center head">Ritenute sociali</div></v-card
            >
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile
              ><div class="text-center head">Ritenute fiscali</div></v-card
            >
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ payroll.totaleLordo | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ payroll.ritenuteSociali | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ payroll.ritenuteFiscali | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile
              ><div class="text-center head">Addizionali Irpef</div></v-card
            >
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile
              ><div class="text-center head">Conguaglio fiscale</div></v-card
            >
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile
              ><div class="text-center head">Arrotondamento</div></v-card
            >
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ payroll.addizionaliIrpef | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ payroll.conguaglioFiscale | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ payroll.arrotondamento | currencyFormat }}
              </div></v-card
            >
          </v-col>
        </v-row>
        <v-row no-gutters class="hidden-md-and-down text-center">
          <v-col cols="2">
            <v-card outlined flat tile>
              <div class="head">Totale lordo</div>
            </v-card>
          </v-col>
          <v-col cols="2"
            ><v-card outlined flat tile>
              <div class="head">Ritenute sociali</div>
            </v-card></v-col
          >
          <v-col cols="2"
            ><v-card outlined flat tile>
              <div class="head">Ritenute fiscali</div>
            </v-card></v-col
          >
          <v-col cols="2"
            ><v-card outlined flat tile>
              <div class="head">Addizionali Irpef</div>
            </v-card></v-col
          >
          <v-col cols="2"
            ><v-card outlined flat tile>
              <div class="head">Conguaglio fiscale</div>
            </v-card></v-col
          >
          <v-col cols="2"
            ><v-card outlined flat tile>
              <div class="head">Arrotondamento</div>
            </v-card></v-col
          >
          <v-col cols="2">
            <v-card outlined flat tile>
              {{ payroll.totaleLordo | currencyFormat }}
            </v-card>
          </v-col>
          <v-col cols="2">
            <v-card outlined flat tile>
              {{ payroll.ritenuteSociali | currencyFormat }}
            </v-card>
          </v-col>
          <v-col cols="2">
            <v-card outlined flat tile>
              {{ payroll.ritenuteFiscali | currencyFormat }}
            </v-card>
          </v-col>
          <v-col cols="2">
            <v-card outlined flat tile>
              {{ payroll.addizionaliIrpef | currencyFormat }}
            </v-card>
          </v-col>
          <v-col cols="2">
            <v-card outlined flat tile>
              {{ payroll.conguaglioFiscale | currencyFormat }}
            </v-card>
          </v-col>
          <v-col cols="2">
            <v-card outlined flat tile>
              {{ payroll.arrotondamento | currencyFormat }}
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <detail-section title="Ferie" :data="payroll.ferie"></detail-section>
          <detail-section
            title="Permessi"
            :data="payroll.permessi"
          ></detail-section>
          <detail-section
            title="Altre movimentazioni"
            :data="payroll.altreMov"
          ></detail-section>
          <detail-section
            title="Banca ore"
            :data="payroll.bancaOre"
          ></detail-section>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            lg="6"
            v-if="
              payroll.presenze.lavorate !== 0.0 ||
              payroll.presenze.straordinario !== 0.0 ||
              payroll.assenze.totale !== 0
            "
          >
            <v-row no-gutters class="mt-2">
              <v-col cols="12">
                <v-card flat tile class="px-1">
                  <div class="text-overline text-center title">
                    totale ore assenze/presenze
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" class="head">
                <v-card outlined flat tile>
                  <div class="text-center head">
                    {{ mesi[payroll.mese - 1] }} {{ payroll.anno }}
                  </div>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card outlined flat tile class="px-1">Lavorate</v-card>
              </v-col>
              <v-col cols="4">
                <v-card outlined flat tile class="px-1">{{
                  payroll.presenze.lavorate | roundNumber
                }}</v-card>
              </v-col>
              <v-col cols="8">
                <v-card outlined flat tile class="px-1">Straordinario</v-card>
              </v-col>
              <v-col cols="4">
                <v-card outlined flat tile class="px-1">{{
                  payroll.presenze.straordinario | roundNumber
                }}</v-card>
              </v-col>
              <v-col cols="8">
                <v-card outlined flat tile class="px-1">Assenze</v-card>
              </v-col>
              <v-col cols="4">
                <v-card outlined flat tile class="px-1">{{
                  payroll.assenze.totale | roundNumber
                }}</v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" lg="6" v-if="payroll.assenze.dettaglio.length > 0">
            <v-row no-gutters class="mt-2">
              <v-col cols="12">
                <v-card flat tile class="px-1">
                  <div class="text-overline text-center title">
                    dettaglio ore assenze
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" class="head">
                <v-card outlined flat tile>
                  <div class="text-center head">
                    {{ mesi[payroll.mese - 1] }} {{ payroll.anno }}
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row
              no-gutters
              v-for="d in payroll.assenze.dettaglio"
              :key="d.codLegenda"
            >
              <v-col cols="8">
                <v-card outlined flat tile class="px-1">{{
                  d.descrizione
                }}</v-card>
              </v-col>
              <v-col cols="4">
                <v-card outlined flat tile class="px-1">{{
                  d.ore | roundNumber
                }}</v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </sea-page-content>
</template>

<script>
import DetailSection from "@/components/PayrollDetailSection.vue";
import mixin from "@/mixin";

export default {
  components: { DetailSection },
  mixins: [mixin],
  props: ["payroll"],
};
</script>

<style></style>
